<div>
  <div class="sana-card-header">
    <div
      class="therapy-plan-title row">
      <div [ngClass]="{ 'col-4': isTitleEditMode, 'col-auto': !isTitleEditMode }">
        @if (isTitleEditMode) {
          <input
            pInputText
            id="title"
            [formControl]="therapyPlanForm.controls.title"
            pSize="small"
            [fluid]="true" />
        } @else {
          {{ therapyPlanForm.controls.title.value }}
        }
      </div>

      <div
        class="col-auto"
        style="padding-left: 0">

        @if (isTitleEditMode) {
          <i
            class="pi pi-check"
            (click)="isTitleEditMode = false"></i>
        } @else {
          <i
            class="pi pi-pencil"
            (click)="isTitleEditMode = true"></i>
        }
      </div>
    </div>
  </div>

  <form
    [formGroup]="therapyPlanForm"
    (ngSubmit)="submit($event)">

    <div class="sana-card-body">
      <div class="row">
        <div class="col-12">
          <form>
            <div class="row gx-3">
              <div class="col-md-6 col-xl-3 sana-form-control">
                <label for="startDate">
                  Start *
                </label>

                <p-date-picker
                  id="startDate"
                  selectionMode="single"
                  [formControl]="therapyPlanForm.controls.startDate"
                  [size]="'small'"
                  [fluid]="true"
                  [dateFormat]="'dd.mm.yy'"
                  [firstDayOfWeek]="1"
                  [minDate]="startDateMinDate"></p-date-picker>

                <small
                  id="startDate-help"
                  class="form-help">
                  Wann beginnt der Therapieplan?
                </small>
              </div>

              <div class="col-md-6 col-xl-3 sana-form-control">
                <label for="durationInWeeks">
                  Dauer des Therapieplans *
                </label>

                <p-select
                  id="durationInWeeks"
                  [formControl]="therapyPlanForm.controls.durationInWeeks"
                  [options]="[1,2,3,4,6]"
                  placeholder="Dauer in Wochen"
                  size="small"
                  [fluid]="true">

                  <ng-template
                      #selectedItem
                      let-selectedEntry>
                    {{ getDurationTranslation(selectedEntry) }}
                  </ng-template>

                  <ng-template
                      let-entry
                      #item>
                    {{ getDurationTranslation(entry) }}
                  </ng-template>
                </p-select>

                <small
                  id="endDate-help"
                  class="form-help">
                  Wie viele Wochen läuft der Therapieplan?
                </small>
              </div>

              <div class="col-md-6 col-xl-3 sana-form-control">
                <label for="amountOfTrainingsPerWeek">Trainings pro Woche *</label>

                <p-input-number
                  id="amountOfTrainingsPerWeek"
                  [formControl]="therapyPlanForm.controls.expectedAmountOfTrainingsPerWeek"
                  [useGrouping]="true"
                  [min]="1"
                  size="small"
                  [fluid]="true" />

                <small
                  id="amountOfTrainingsPerWeek-help"
                  class="form-help">
                  Wie oft soll der Patient pro Woche üben?
                </small>
              </div>

              <div class="col-md-6 col-xl-3 sana-form-control">
                <label for="status">Status *</label>

                <p-select
                  id="status"
                  [formControl]="therapyPlanForm.controls.status"
                  [options]="[TherapyPlanStatusEnum.Started, TherapyPlanStatusEnum.Planned]"
                  placeholder="Status"
                  size="small"
                  [fluid]="true">

                  <ng-template
                      #selectedItem
                      let-selectedEntry>
                    {{ TherapyPlanStatusTranslations.getTranslationByKey(selectedEntry) }}
                  </ng-template>

                  <ng-template
                      let-entry
                      #item>
                    {{ TherapyPlanStatusTranslations.getTranslationByKey(entry) }}
                  </ng-template>
                </p-select>
              </div>

              @if (this.hasPreviousTherapyPlans()) {
                <div class="col-12 sana-form-control">
                  <div
                    class="d-flex align-items-center"
                    style="gap: .5rem">
                    <p-checkbox
                      [formControl]="therapyPlanForm.controls.closePreviousTherapyPlan"
                      inputId="closePreviousTherapyPlan"
                      [value]="true"
                      [binary]="true"
                      size="small" />

                    <label
                      for="closePreviousTherapyPlan"
                      class="text-sm">
                      Vorherigen Therapieplan abschließen
                    </label>
                  </div>
                </div>
              }
            </div>
          </form>
        </div>

        <div class="col-12">
          <sana-tp-exercise-entry-list-wrapper
            [clientId]="selectedClient()!.id!"
            [templateExerciseList]="selectedExerciseList!"
            (formValueChanged)="updateTherapyPlanExercises($event)"
            (removeExercise)="removeExercise($event)"
            (formStatusChanged)="isExerciseWithTrainingSetFormValid = $event"></sana-tp-exercise-entry-list-wrapper>
        </div>

        <div class="col-12">
          <p-button
            type="submit"
            class="d-flex justify-content-end"
            severity="primary"
            size="small"
            [label]="selectedTherapyPlan() ? 'Abschnitt speichern' : 'Therapieplan speichern'"
            [disabled]="isSaving"
            [loading]="isSaving"
            icon="pi pi-save" />
        </div>
      </div>
    </div>
  </form>
</div>

<p-confirm-dialog
  [focusTrap]="true"
  [style]="{'line-height': '1.5'}"></p-confirm-dialog>
